import request from '../utils/request'

/**
 * 仪表盘相关API服务
 */
const dashboardService = {
    /**
     * 获取仪表盘统计数据
     * @returns {Promise} 包含统计数据的Promise对象
     */
    getStats() {
        return request({
            url: '/api/dashboard/stats',
            method: 'get'
        })
    },

    /**
     * 获取投资人驾驶舱统计数据（出资方视角：出资/回收/在投余额/趋势/排名）
     * @returns {Promise} 包含投资人统计数据的Promise对象
     */
    getInvestorStats() {
        return request({
            url: '/api/dashboard/investor',
            method: 'get'
        })
    },

    /**
     * 获取最近活动数据
     * @returns {Promise} 包含活动数据的Promise对象
     */
    getRecentActivities() {
        return request({
            url: '/api/dashboard/recent-activities',
            method: 'get'
        })
    },

    /**
     * 获取用户增长趋势数据
     * @param {Object} params - 查询参数，包含startDate和endDate
     * @returns {Promise} 包含趋势数据的Promise对象
     */
    getUserGrowthTrend(params) {
        return request({
            url: '/api/dashboard/user-growth',
            method: 'get',
            params
        })
    }
}

export default dashboardService
